import { render, staticRenderFns } from "./TextIcon.vue?vue&type=template&id=50599f5e&scoped=true"
import script from "./TextIcon.vue?vue&type=script&lang=js"
export * from "./TextIcon.vue?vue&type=script&lang=js"
import style0 from "./TextIcon.vue?vue&type=style&index=0&id=50599f5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50599f5e",
  null
  
)

export default component.exports